/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Still_Wolf_HowlInputs */

const en_wry_still_wolf_howl = /** @type {(inputs: Wry_Still_Wolf_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granted Reports`)
};

const de_wry_still_wolf_howl = /** @type {(inputs: Wry_Still_Wolf_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigegebene Berichte`)
};

/**
* | output |
* | --- |
* | "Granted Reports" |
*
* @param {Wry_Still_Wolf_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_still_wolf_howl = /** @type {((inputs?: Wry_Still_Wolf_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Still_Wolf_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_still_wolf_howl(inputs)
	return de_wry_still_wolf_howl(inputs)
});